export const Tooltip = 'atlantis-tooltip';